import React from 'react';
import DonateButtonPreview from './DonateButtonPreview';
import ImageButtonPreview from './ImageButtonPreview';
import PropTypes from 'prop-types';

const ButtonPreviewContainer = ({
  usePaypalButtonStyle,
  showAcceptedCardLogos,
  buttonSize,
  locale,
  country,
  buttonLocaleUrls,
  buttonImageUrl,
  onError,
}) => {
  return (
    <div className="button-preview-container">
      <div className="button-preview">
        {usePaypalButtonStyle ? (
          <DonateButtonPreview
            showAcceptedCardLogos={!!showAcceptedCardLogos}
            buttonSize={buttonSize}
            locale={locale}
            country={country}
            buttonLocaleUrls={buttonLocaleUrls}
          />
        ) : (
          <ImageButtonPreview
            buttonImageUrl={buttonImageUrl}
            onError={onError}
          />
        )}
      </div>
    </div>
  );
};
ButtonPreviewContainer.propTypes = {
  usePaypalButtonStyle: PropTypes.bool,
  buttonSize: PropTypes.string,
  showAcceptedCardLogos: PropTypes.bool,
  locale: PropTypes.string,
  country: PropTypes.string,
  buttonImageUrl: PropTypes.string,
  onError: PropTypes.func,
  buttonLocaleUrls: PropTypes.object,
};

export default ButtonPreviewContainer;
